import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import ChipText from "@core-components/chip-text/ChipText";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import HappyCustomerCount from "./HappyCustomerCount";

const ReviewHero = () => {
  const { t } = useAppTranslation("pages.reviews");

  return (
    <>
      <HappyCustomerCount />
      <SSBackgroundImage>
        <SSBgImageHeadline
          subTitle={
            <ChipText
              className="mx-4 mt-16 text-center"
              label={<strong>{t("banner.chip")}</strong>}
            />
          }
          props={{ title: { order: 1 } }}
        >
          <SSWhiteText className={"text-[35px] xs:text-[50px]"}>
            {t("banner.titlePrefix")}
          </SSWhiteText>
          <br />
          &nbsp;
          <SSLoLGradientText className={"text-[35px] xs:text-[50px]"}>
            {t("banner.titleSuffix")}
          </SSLoLGradientText>
        </SSBgImageHeadline>
      </SSBackgroundImage>
    </>
  );
};

export default ReviewHero;
